module.exports = __webpack_public_path__ + "img/img1.c490a83d.jpg";